module.exports = __webpack_public_path__ + "img/carousel-vet-12.d8f6e94d.jpg";